import { createRootRouteWithContext, redirect } from "@tanstack/react-router";
import {
  RouteErrorComponent,
  RoutePendingFallback,
} from "@/app/router/components/RouteBoundaries";
import type { RouterContext } from "@/app/router/types";
import { RootLayout } from "@/routes/root/RootLayout";

function serializeSearchParams(search: Record<string, string>): string {
  const searchParams = new URLSearchParams();
  const searchObject = search;

  if (searchObject) {
    Object.entries(searchObject).forEach(([key, value]) => {
      if (value !== "" && value !== null) {
        searchParams.append(key, String(value));
      }
    });
  }

  return searchParams.toString();
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ context, location }) => {
    const isAuthPath = location.pathname.startsWith("/auth");
    if (!isAuthPath) {
      if (!context.isAuthenticated()) {
        const searchString = serializeSearchParams(location.search);
        const originalUrl =
          location.pathname + (searchString ? `?${searchString}` : "");

        throw redirect({
          to: "/auth/login",
          search: { redirect: originalUrl },
          replace: true,
        });
      }

      const roles = context.getUserRoles();
      if (!roles || roles.length === 0) {
        throw redirect({ to: "/auth/unauthorized", replace: true });
      }
    }
  },
  component: RootLayout,
  pendingComponent: RoutePendingFallback,
  errorComponent: RouteErrorComponent,
  notFoundComponent: () => (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center text-slate-200">
      <h2 className="text-lg font-semibold uppercase tracking-[0.35em] text-red-200">
        404 - Off Track
      </h2>
      <p className="max-w-md text-sm text-slate-400">
        The page you're looking for does not exist. Verify the URL or navigate
        back to the home page.
      </p>
    </div>
  ),
});
